import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrganisationDto } from '@careapp-group/ng-sdk-v2-new';
import { Observable } from 'rxjs';

export interface OrganisationSelectDialogData {
  organisations: Observable<{ [key: string]: OrganisationDto }>;
  initialSelectedIds: string[];
}

@Component({
  selector: 'ca-organisation-list-select-dialog',
  templateUrl: './organisation-list-select-dialog.component.html',
  styleUrls: ['./organisation-list-select-dialog.component.scss'],
})
export class OrganisationListSelectDialogComponent implements OnInit {
  _search = '';
  public selectedIds: string[] = [];
  public tableConfig = [
    {
      key: 'name',
      sortable: false,
      title: 'Organisation',
    },
  ];
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: OrganisationSelectDialogData
  ) {}

  ngOnInit() {
    this.selectedIds = [...(this.data.initialSelectedIds ?? [])];
  }

  toggle(organisation: OrganisationDto) {
    const isSelected = !!this.selectedIds.find((id) => id === organisation.id);

    this.selectedIds = isSelected
      ? this.selectedIds.filter((id) => id !== organisation.id)
      : [...this.selectedIds, organisation.id];
  }

  set search(value: string) {
    this._search = value;
  }
  get search() {
    return this._search;
  }
  get selectedIdFilter() {
    return (item: OrganisationDto, _) => item && this.selectedIds.includes(item.id);
  }

  selectOrgs(orgs: { [key: string]: OrganisationDto }) {
    this.selectedIds = Object.keys(orgs);
  }
}
